export default "__VITE_ASSET__BAHCLglP__"